import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LottieAnimationComponent } from '@shared/components/lottie-animation/lottie-animation.component';
import { AppButtonDirective } from '@shared/ui/button/app-button.directive';

@Component({
  selector: 'app-not-found',
  host: {
    class: 'flex-grow',
  },
  imports: [LottieAnimationComponent, AppButtonDirective],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  private readonly _router = inject(Router);
  private readonly _route = inject(ActivatedRoute);

  onBack() {
    this._router.navigate(['/'], { relativeTo: this._route });
  }
}
